module.exports = __webpack_public_path__ + "img/Report_1__First_Canal_Randall_recommends_Gravelly_Bay_1831.4b3659b4.jpg";